import React from 'react';
import styled from 'styled-components';
import { ExceedTimeLimitPanel } from '@components/common';

export const VM_TIME_LIMIT = 24; // in hours

export const StyledExceedTimeLimitPanel = styled(ExceedTimeLimitPanel)`
  position: relative;
  left: 50%;
  top: 30px;
  margin-left: -350px;
  padding: 10px;
`;

export const BucketLimit = () => (
  <StyledExceedTimeLimitPanel title="">
    <p>
      Switch to distribution in chart to select a range for analysis.
    </p>
  </StyledExceedTimeLimitPanel>
);

export const TimeLimit = () => (
  <StyledExceedTimeLimitPanel title={`Select upto ${VM_TIME_LIMIT} hours time range within last 30 days`}>
    <p>
      - Use the Date/Time Picker to set the time range up to {VM_TIME_LIMIT} hours, for
      example Sep 14 2023 00:00 - 23:59.
    </p>
    <p>- Drag in the time series to set the time range up to {VM_TIME_LIMIT} hours.</p>
  </StyledExceedTimeLimitPanel>
);
